
export class ProductCategory {
    _id: string;
    Key: string;
    DisplayIndex: number;
    ImageUrl: string;
}

function ProductCategory_tsickle_Closure_declarations() {
/** @type {?} */
ProductCategory.prototype._id;
/** @type {?} */
ProductCategory.prototype.Key;
/** @type {?} */
ProductCategory.prototype.DisplayIndex;
/** @type {?} */
ProductCategory.prototype.ImageUrl;
}
